import { ICoreContext } from '@msdyn365-commerce/core';

export function getAllowedCountiesIds(context: ICoreContext): string[] {
    const allowedCounties = context?.actionContext?.requestContext?.app?.config?.allowedCounties;
    if (allowedCounties?.length) {
        const allowedCountiesIds = allowedCounties.map((county: any) => county?.countyId).filter((id: string) => !!id);
        return allowedCountiesIds ?? [];
    }
    return [];
}
